module.exports = __webpack_public_path__ + "media/images/pages/bg_area_03-45edffeb2f7d07528e0b58eac79958d9.png";